import { AddNewConnectedCasesWireData, ChangeCaseStatusWireData } from "app/area/case/features/calls-to-actions/types";
import { ComplexValue } from "ui";

export const ACTION = {
  REQUEST_CALLS_TO_ACTIONS: 'CASE:REQUEST_CALLS_TOS_ACTIONS',
  RECEIVE_CALLS_TO_ACTIONS: 'CASE:REQUEST_CALLS_TOS_ACTIONS',
  REQUEST_CHANGE_STATUS: 'CASE:REQUEST_CHANGE_STATUS',
  RECEIVE_CHANGE_STATUS: 'CASE:RECEIVE_CHANGE_STATUS',
  REQUEST_CONNECT_EXISTING: 'CASE:REQUEST_CONNECT_EXISTING',
  RECEIVE_CONNECT_EXISTING: 'CASE:RECEIVE_CONNECT_EXISTING',
  REQUEST_DISCONNECT_CASE: 'CASE:REQUEST_DISCONNECT_CASE',
  RECEIVE_DISCONNECT_CASE: 'CASE:RECEIVE_DISCONNECT_CASE'
};

export class RequestCallsToActions {
  public type: string = ACTION.REQUEST_CALLS_TO_ACTIONS;
  public caseId: number;

  constructor(caseId: number) {
    this.caseId = caseId;
  }
}

export class ReceiveCallsToActions {
  public type: string = ACTION.RECEIVE_CALLS_TO_ACTIONS;
  constructor(public callsToActions: {
    changeStatus: ChangeCaseStatusWireData;
    addNewConnectedCases: AddNewConnectedCasesWireData[];
  }) {
    this.callsToActions = callsToActions;
  }
}

export class RequestChangeCaseStatus {
  public type: string = ACTION.REQUEST_CHANGE_STATUS;
  public caseId: number;

  constructor(caseId: number) {
    this.caseId = caseId;
  }
}

export class ReceiveChangeCaseStatus {
  public type: string = ACTION.RECEIVE_CHANGE_STATUS;
  constructor(public status: ComplexValue<any>) {}
}

export class RequestConnectExisting {
  public type: string = ACTION.REQUEST_CONNECT_EXISTING;
  public caseId: number;

  constructor(caseId: number) {
    this.caseId = caseId;
  }
}

export class ReceiveConnectExisting {
  public type: string = ACTION.RECEIVE_CONNECT_EXISTING;
  constructor() {}
}

export class RequestDisconnectCase {
  public type: string = ACTION.REQUEST_DISCONNECT_CASE;
  constructor() {}
}

export class ReceiveDisconnectCase {
  public type: string = ACTION.RECEIVE_DISCONNECT_CASE;
  constructor() {}
}
